import thunk from "redux-thunk";

import { isDevelopment, isShadow } from "./utils/isDevelopment";
import ErrorReporting from "./utils/errorReporting";
import { createReduxStore } from "./utils/store";
import { fetchRegistration } from "./actions/registrationActions";
import { fetchBranding } from "./actions/brandingActions";
import renderSelfRegistration from "./SelfRegistration";

export const init = async () => {
  //catch errors and report to Airbrake
  const errorReporting = new ErrorReporting({
    isEnabled: !isDevelopment,
    environment: process.env.REACT_APP_ENVIRONMENT || "development",
    projectId: process.env.REACT_APP_AIRBRAKE_PROJECT_ID,
    projectKey: process.env.REACT_APP_AIRBRAKE_PROJECT_KEY
  });

  const store = createReduxStore({
    isDevelopment: (isDevelopment || isShadow),
    middlewares: [
      errorReporting.getAirbrakeMiddleware(),
      thunk
    ],
  });

  store.dispatch(fetchBranding());
  store.dispatch(fetchRegistration());

  renderSelfRegistration({
    store,
    airbrake: errorReporting.getAirbrakeClient()
  });
};
